import React, {Component} from 'react';
import { Button, Toast } from 'antd-mobile';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import TipPlaceholder from '../components/TipPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';
import { createForm } from 'rc-form';

class DebugPay extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orderNo: null,
            status: 'loading',
            enablePay: true,
        }
    }

    componentDidMount() {
        let orderNo = CommonUtils.resolveSearchParam(this.props.location, 'orderNo')
        if(CommonUtils.isEmpty(orderNo)) {
            this.setState({
                status: 'noauth'
            })
        } else {
            this.setState({
                orderNo,
                status: 'success'
            })
        }
    }

    handlePay = () => {
        const { enablePay, orderNo } = this.state
        if(!enablePay) {
            Toast.info('购买中')
            return;
        }

        this.setState({
            enablePay: false
        })
        Toast.info('支付跳转中')
        DataFetcher.debugPay(
            {
                orderNo: orderNo
            }, 
            (resp) => {
                CommonUtils.invokeWechatPay(resp.data, () => {
                    Toast.info('支付完成！', 5)
                })
            },
            () => {
                this.setState({
                    enablePay: true
                })
            }
        )
    }

    generateBindView() {
        const { userProfile, deviceInfo } = this.state
        if(!userProfile.agentId || !deviceInfo.deviceId || deviceInfo.agentId) {
            return
        }

        return (
            <div className='section-bind'>
                <div className="title word-ellipsis">
                    <span className='main'><i className='iconfont icon-diannao'></i> 绑定设备</span>
                    <span className='sub'></span>
                </div>
                <div className='wrapper-bind-info'>
                    <div className='operation'>
                        <button onClick={() => {this.setState({bindModalVisible: true})}}>开始绑定</button>
                    </div>
                </div>
            </div>
        )
    }


    generatePayView() {
        const { orderNo } = this.state
        return (
            <div>
                <div>orderNo: {orderNo}</div>
                <Button onClick={this.handlePay}>Debug</Button>
            </div>
        )
    }

    doRenderView() {
        return (
            <div className="page-debug-pay">
                {this.generatePayView()}
            </div>
        )
    }

    render() {
        const {status} = this.state;

        if(status === 'loading') {
            return <LoadingPlaceholder/>;
        } else if (status === 'noauth') {
            return <TipPlaceholder firstTip={Constants.Strings.APP_NAME} secondTip={'请重新扫码'}/>;
        } else {
            return this.doRenderView()
        }
    }
}

export default createForm()(DebugPay);


// WEBPACK FOOTER //
// ./src/modules/DebugPay.js